var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstantBookReverse = function SvgInstantBookReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F4C064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.564 9.915H3.385c-.32 0-.5-.369-.302-.62l5.64-7.147c.253-.32.767-.078.678.32l-.922 4.128h4.136c.319 0 .5.365.304.617l-5.127 6.636c-.239.31-.735.107-.686-.28l.458-3.654Z",
    fill: "#102A5E"
  })));
};
export default SvgInstantBookReverse;